import router from './router'

export default {
	moduleName: 'visual',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/visual/index.js